import $ from 'jquery';

function onShow(e) {
    const hash = $(e.target).attr('href');
    if (hash.includes('#')) {
        window.location.replace(hash);
    }
}

export function init(namespace = 'tab'){
    if (window.location.hash.includes(namespace)) {
        $(`a[href='${window.location.hash}']`).tab('show');
    }

    $('[data-toggle="tab"]').on('show.bs.tab', onShow);
}

export default {
    init
};
